export const loanTableComponent = {
	bindings: {
		loanInfo: '<'
	},
	templateUrl: 'loan-table.html',
	controller: class loanTableComponent {
		constructor($scope, $timeout) {
			'ngInject';
			this.$scope = $scope;
			this.$timeout = $timeout;
		}

		$onChanges(changes) {
			if (changes.loanInfo) {
				this.loanInformation = angular.copy(this.loanInfo);
			}
		}

		clickOnChangeLoan($event) {
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}
	}
};
